import { Calendar } from 'lucide-react';
import { CardShell, EmptyState } from './card-shell';

export function TodayAgendaCard() {
  return (
    <CardShell title="Agenda de hoje" icon={Calendar}>
      <EmptyState
        icon={Calendar}
        message="Sem compromissos hoje."
        cta={{ label: 'Abrir agenda', href: '/escritorio/agenda' }}
      />
    </CardShell>
  );
}
